export default __webpack_public_path__ + "static/media/cloud6.95817956.svg";